<template>
    <div class="wrapper">
        <div class="status" />
        <div class="prediction-versus">
            <div class="partner-logo" />
            <div class="versus-middle" />
            <div class="partner-logo" />
        </div>
        <div class="center">
            <div class="question" />
            <div class="match-time" />
            <div class="additional-info" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'prediction-tile-skeleton-v2',
};
</script>

<style lang="scss" scoped>
.wrapper {
    margin: 0.5rem 1rem 5rem;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 1rem;
    background-color: $white-color;
    border-radius: 8px;
}

.status {
    margin-bottom: 2.8rem;
    width: 18rem;
    height: 1.7rem;
    background: $skeleton-gradient;
    border-radius: 4px;
}

.prediction-versus {
    display: flex;
    align-items: center;
    justify-content: center;
}

.versus-middle {
    margin: 0 2rem;
    width: 8.4rem;
    height: 5.4rem;
    background: $skeleton-gradient;
    border-radius: 4px;
}

.partner-logo {
    width: 7rem;
    height: 7rem;
    background: $skeleton-gradient;
    border-radius: 50%;
}

.center {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.question {
    margin-top: 1rem;
    width: 30rem;
    height: 2rem;
    background: $skeleton-gradient;
    border-radius: 18px;
}

.match-time {
    margin-top: 1rem;
    width: 26rem;
    height: 1.8rem;
    background: $skeleton-gradient;
    border-radius: 18px;
}

.additional-info {
    margin-top: 1rem;
    width: 22rem;
    height: 1.5rem;
    background: $skeleton-gradient;
    border-radius: 18px;
}
</style>